var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadings"},[_c('div',{staticClass:"first-loading-wrp"},[_c('div',{staticClass:"loading-wrp"},[_c('span',{staticClass:"dot dot-spin"},[_c('i'),_c('i'),_c('i'),_c('i')])]),_c('h1',{staticStyle:{"color":"rebeccapurple","margin-top":"-80px"}},[_vm._v(" AIGo.work")])])])
}]

export { render, staticRenderFns }